import { ASYNC_STATUS_ID } from 'constants'
import { API } from 'constants/apiEndPoints'
import { useEffect, useState } from 'react'
import { useAPI } from 'utils/hooks/useAPI'

export const useWalletTransactionData = (activeTab) => {
  const [data, setData] = useState([])
  const [isPending, setPending] = useState()

  const endPointSelector =
    {
      deposit: API.ACCOUNT_TRANSACTIONS_DEPOSIT,
      withdraw: API.ACCOUNT_TRANSACTIONS_WITHDRAW,
    }[activeTab] || API.ACCOUNT_TRANSACTIONS_DEPOSIT

  const [txsState, sendTxsQuery, hasTxsStatus] = useAPI(endPointSelector, {
    queryType: 'get',
    withJwt: true,
    controlled: true,
  })

  useEffect(() => {
    setPending(true)
    sendTxsQuery()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (hasTxsStatus(ASYNC_STATUS_ID.CONFIRMED)) {
      if (!Object.keys(txsState.data).length) return null
      const data = txsState.data?.transactions
      setData(data)
      setPending(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [txsState.status?.id, txsState?.data])

  return { data, isPending }
}
